<template>
    <div
        class="border border-primary bg-white rounded-2xl p-4 w-full xl:w-[430px]"
        :class="{'xl:w-[330px]' : miniatureMode}"
    >
        <div>
            <Carousel :photos="gallery.pictures || []" />
            <div class="relative">
                <div
                    class="absolute right-4 bottom-4 cursor-pointer hover:bg-white"
                    @click="showInModal(gallery.pictures)"
                >
                    <Icon name="Expandir" />
                </div>
            </div>
        </div>
        <div class="mt-5 flex w-full">
            <div class="flex flex-col gap-y-3 w-full">
                <div>
                    <div v-if="gallery.validation?.positionStage2 || gallery.validation?.positionStage3 || gallery.validation?.positionStage4" class="flex flex-col gap-y-3">
                        <div class="flex flex-col">
                            <h1 class="text-primary font-bold">Ranking das Melhores Fotos</h1>
                            <div class="flex flex-col gap-y-2">
                                <div v-if="gallery.validation?.positionStage2" class="flex border rounded-2xl p-2 items-center justify-between">
                                    Nível 2
                                    <div class="flex gap-x-2">
                                        <div class="border rounded-full h-8 px-2 flex justify-center items-center bg-primary text-white">
                                            {{ computedStage2Badge }}
                                        </div>
                                        <div class="border rounded-full w-8 h-8 flex justify-center items-center bg-primary text-white">
                                            {{ gallery.validation?.positionStage2 }}º
                                        </div>
                                    </div>
                                </div>
                                <div v-if="gallery.validation?.positionStage3" class="flex border rounded-2xl p-2 items-center justify-between">
                                    Nível 3
                                    <div class="flex gap-x-2">
                                        <div class="border rounded-full h-8 px-2 flex justify-center items-center bg-primary text-white">
                                            {{ computedStage3Badge }}
                                        </div>
                                        <div class="border rounded-full w-8 h-8 flex justify-center items-center bg-primary text-white">
                                            {{ gallery.validation?.positionStage3 }}º
                                        </div>
                                    </div>
                                </div>
                                <div v-if="gallery.validation?.positionStage4" class="flex border rounded-2xl p-2 items-center justify-between">
                                    Nível 4
                                    <div class="flex gap-x-2">
                                        <div class="border rounded-full h-8 px-2 flex justify-center items-center bg-primary text-white">
                                            {{ computedStage4Badge }}
                                        </div>
                                        <div class="border rounded-full w-8 h-8 flex justify-center items-center bg-primary text-white">
                                            {{ gallery.validation?.positionStage4 }}º
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else class="flex justify-center">
                        <div class="border border-primary rounded-2xl px-4 py-2 flex">
                            <div>
                                <div class="flex gap-x-1.5">
                                    <div v-for="(star, key) in [1, 2, 3]" :key="key">
                                        <label
                                            v-bind:class="{
                                                'cursor-pointer': isAllowedToVote,
                                            }"
                                            @mouseenter="
                                                gallery.tempValue =
                                                    getCurrentStarValue(star)
                                            "
                                            @mouseleave="
                                                gallery.tempValue =
                                                    gallery.validation?.level
                                            "
                                        >
                                            <Icon
                                                name="EstrelaHover"
                                                :disabled="isAllowedToVote"
                                                :isFill="
                                                    isAllowedToVote
                                                        ? (gallery.tempValue ||
                                                            gallery.validation?.level) >=
                                                        star
                                                        : gallery.validation?.level >= star
                                                "
                                                @click="vote(star)"
                                            />
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <link
                            rel="stylesheet"
                            href="//maxcdn.bootstrapcdn.com/font-awesome/4.3.0/css/font-awesome.min.css"
                        />
                    </div>
                </div>
                <div v-if="!miniatureMode" class="flex flex-col gap-y-3 w-full">
                    <div>
                        <div class="flex items-center gap-x-2">
                            <h1 class="text-primary font-bold">Participante(s)</h1> 
                        </div>
                        <p @click="showParticipants()" class="cursor-pointer hover:underline hover:text-blue-500">{{ gallery.userCreated?.name }}</p>
                    </div>
                    <div>
                        <h1 class="text-primary font-bold">Sold</h1>
                        <p>{{ gallery.pdv?.codeSoldBroker }}</p>
                    </div>
                    <div>
                        <h1 class="text-primary font-bold">
                            Regional / Sub-regional
                        </h1>
                        <p>
                            {{ gallery.pdv?.region }} /
                            {{ gallery.pdv?.subregion.name }}
                        </p>
                    </div>
                    <div>
                        <h1 class="text-primary font-bold">Canal</h1>
                        <p>{{ gallery.pdv?.canal }}</p>
                    </div>
                    <div>
                        <h1 class="text-primary font-bold whitespace-nowrap">
                            Tipo de Execução
                        </h1>
                        <p>{{ gallery.executionType?.description }}</p>
                    </div>
                    <div>
                        <h1 class="text-primary font-bold">Campanha</h1>
                        <p>{{ handleContestName(gallery.contest) }}</p>
                    </div>
                    <div>
                        <h1 class="text-primary font-bold">Categoria</h1>
                        <p v-if="gallery.categories?.length === 0">NÃO ENCONTRADO</p>
                        <p v-for="(category, key) in handleSubcategories(gallery.categories)" :key="key">{{ category }}</p>
                    </div>
                    <div>
                        <h1 class="text-primary font-bold">Senha Semanal</h1>
                        <p>{{ gallery.weeklypassphrase }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from "moment";
import { Head } from "@inertiajs/inertia-vue3";
import Heading from "@/Components/UI/Texts/Heading.vue";
import Icon from "@/Components/UI/Icons/Icon.vue";
import Carousel from "@/Components/CarouselSimple.vue";

export default {
    components: {
        Head,
        Heading,
        Head,
        Icon,
        Carousel,
    },

    emits: ["showParticipants", "showPictures"],

    props: {
        gallery: Object,
        showInModal: Function,
        miniatureMode: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        computedStage2Badge() {
            const {contest} = this.gallery;

            if(!contest) {
                return 'N/A' 
            }

            if(contest.winningType == "S") {
                return this.gallery.pdv?.subregion.name;
            } else {
                return this.gallery.pdv?.region;
            }
        },
        computedStage3Badge() {
            const {contest} = this.gallery;

            if(!contest) {
                return 'N/A' 
            }

            if(contest.winningType == "S") {
                return this.gallery.pdv?.subregion.name;
            }
            if(contest.winningType == "R") {
                return this.gallery.pdv?.region;
            }
            if(contest.winningType == "N") {
                return "NACIONAL";
            }
        },
        computedStage4Badge() {
            const {contest} = this.gallery;

            if(!contest) {
                return 'N/A' 
            }

            if(contest.podiumType == "S") {
                return this.gallery.pdv?.subregion.name;
            }
            if(contest.podiumType == "R") {
                return this.gallery.pdv?.region;
            }
            if(contest.podiumType == "N") {
                return "NACIONAL";
            }
        }
    },
    methods: {
        handleContestName(contest) {
            return `${contest.name} (${moment(contest.startDate)
                .locale("pt-br")
                .format("MMM")
                .toUpperCase()} à ${moment(contest.endDate)
                .locale("pt-br")
                .format("MMM")
                .toUpperCase()})`;
        },
        handleSubcategories(categories) {
            return categories.map(el => el.description)
        },
        showParticipants() {
            this.$emit('showParticipants', this.gallery.participants);
        },
    },
};
</script>